import { HeaderIconItem, HeaderIconItemType, useHeaderIconItems } from "./AppMenuIconItems";
import { Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from "@fluentui/react-components";
import React, { useCallback, useMemo, useState } from "react";

import { AppMenuFlyout } from "./Flyouts/AppMenuFlyout";
import { Enums } from "Shared/Utils";
import { MoreVertical20Regular } from "@fluentui/react-icons";
import { observer } from "mobx-react";
import { useStyles } from "./ShowMore.styles";

interface ClickableHeaderIconItem extends HeaderIconItem {
    onClick: () => void;
}

const ShowMoreBase = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState<HeaderIconItem | null>(null);
    const classNames = useStyles();

    const headerIconItems = useHeaderIconItems();

    const onDismiss = useCallback(() => {
        setIsOpen(false);
    }, []);

    const onClickItem = useCallback(
        (itemKey: string) => {
            const selectedKey = Enums.getEnumValueFromKey(itemKey, HeaderIconItemType);
            const selected = headerIconItems.find((item) => item.key === selectedKey);
            setSelectedItem(selected ?? null);
            if (selected?.onClick) {
                selected.onClick();
            } else {
                setIsOpen(!isOpen);
            }
        },
        [headerIconItems, isOpen]
    );

    const items: ClickableHeaderIconItem[] = useMemo(
        () =>
            headerIconItems
                .filter((item) => item.isHiddenOnSmallScreen !== true)
                .map((item) => ({
                    ...item,
                    onClick: () => onClickItem(HeaderIconItemType[item.key])
                })),
        [headerIconItems, onClickItem]
    );

    const renderMenuList = useMemo(
        () => (
            <MenuList>
                {items.map((item) => (
                    <MenuItem key={item.key} icon={<item.icon />} onClick={item.onClick} className={classNames.menuItem}>
                        {item.displayName}
                    </MenuItem>
                ))}
            </MenuList>
        ),
        [classNames.menuItem, items]
    );

    return (
        <div>
            <Menu positioning="below">
                <MenuTrigger>
                    <div className={classNames.iconContainer} aria-label="More options">
                        <MoreVertical20Regular />
                    </div>
                </MenuTrigger>
                <MenuPopover>{renderMenuList}</MenuPopover>
            </Menu>
            {selectedItem && <AppMenuFlyout showFlyout={isOpen} onDismiss={onDismiss} menuItem={selectedItem} />}
        </div>
    );
};

export const ShowMore = observer(ShowMoreBase);
